module.exports = __webpack_public_path__ + "img/9AI-改3_09.f6168d3d.jpg";